xplenty.filter('calendar', [
  function () {
    return function (referenceTime, timezone) {
      const t = moment(referenceTime);
      t.utcOffset(timezone || window.DEFAULT_TIMEZONE);
      return t.calendar();
    };
  },
]);
